import json from "../translations.json";

export const translations = {
  namespaced: true,
  state: json
};
